<div class="rich-table-shell">
  <div
    *ngIf="(canDownload || showTableSearch) && isRia"
    class="rich-table__toolbar"
    [class.rich-table__toolbar--with-search]="showTableSearch"
  >
    <div
      *ngIf="showTableSearch"
      class="rich-table__search"
      [class.rich-table__search--active]="isTableSearchActive"
    >
      <img
        src="assets/icons/search.svg"
        alt=""
        class="rich-table__search-icon"
        aria-hidden="true"
      />
      <input
        type="search"
        class="rich-table__search-input"
        placeholder="Enter keywords to search"
        [value]="searchQuery"
        (input)="onSearchInput($event)"
        aria-label="Search table"
        autocomplete="off"
      />
    </div>
    <button
      *ngIf="canDownload"
      type="button"
      class="rich-table__download-button"
      aria-label="Download table as spreadsheet"
      (click)="openDownloadModal($event)"
    >
      Download
    </button>
  </div>

  <div
    class="rich-table-host"
    data-rich-table="true"
    [class.rich-table-host--fixed-viewport]="shouldUseFixedViewport"
    [class.rich-table-host--fill]="isFillLayout"
    [class.rich-table-host--overflow]="isOverflowLayout"
  >
  <div *ngIf="canDownload && !isRia" class="rich-table__toolbar">
    <button
      type="button"
      class="rich-table__download-button"
      aria-label="Download table as spreadsheet"
      (click)="openDownloadModal($event)"
    >
      <em class="icon-download rich-table__download-icon" aria-hidden="true"></em>
      Download
    </button>
  </div>

  <div *ngIf="!useStructuredTable" class="rich-table__scroll">
    <div class="markdown-content">
      <div [innerHTML]="tableMarkdown | sanitizeMarkdown"></div>
    </div>
  </div>

  <ng-container *ngIf="useStructuredTable && tableData">
    <div
      class="rich-table__scroll"
      [class.rich-table__wrap--resizing-columns]="isResizingColumns"
      [class.rich-table__wrap--resizing-rows]="isResizingRows"
    >
      <div class="markdown-content">
        <div
          class="rich-table__wrap"
          [class.rich-table__wrap--resizable]="canResizeColumns"
        >
          <table
            class="rich-table__table"
            [class.wide-table]="isWideTable"
            [class.rich-table__table--fill]="isFillLayout"
            [class.rich-table__table--overflow]="isOverflowLayout"
            [style.min-width.px]="tableMinWidthPx"
          >
            <colgroup *ngIf="hasColumnWidthLayout && columnWidths">
              <col
                *ngFor="let width of columnWidths; let colIndex = index"
                [style.width]="columnWidthStyle(colIndex)"
              />
            </colgroup>
            <thead>
              <tr>
                <th
                  *ngFor="let column of tableData.columns; let colIndex = index"
                  #headerCell
                  [class]="headerDensityClass(column)"
                  [class.rich-table__th--filterable]="showTableColumnFilter"
                >
                  <div class="rich-table__header-cell">
                    <span
                      *ngIf="usePlainTextCells; else headerRichMarkdown"
                      class="rich-table__cell-content rich-table__cell-content--header"
                    >{{ column }}</span>
                    <ng-template #headerRichMarkdown>
                      <span
                        class="rich-table__cell-content rich-table__cell-content--header"
                        [innerHTML]="cellMarkdownSource(column) | sanitizeMarkdown"
                      ></span>
                    </ng-template>
                    <div *ngIf="showTableColumnFilter" class="rich-table__header-actions">
                      <button
                        type="button"
                        class="rich-table__filter-trigger"
                        [class.rich-table__filter-trigger--active]="isColumnFilterActive(colIndex)"
                        [class.rich-table__filter-trigger--visible]="isFilterTriggerVisible(colIndex)"
                        [attr.aria-label]="'Filter ' + (column || 'column ' + (colIndex + 1))"
                        [attr.aria-expanded]="openFilterColumnIndex === colIndex"
                        (click)="toggleFilterMenu(colIndex, $event)"
                      >
                        <img
                          src="assets/icons/filter-search.svg"
                          alt=""
                          class="rich-table__filter-icon"
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </div>
                  <span
                    *ngIf="canResizeColumns && colIndex < tableData.columns.length - 1"
                    role="separator"
                    aria-orientation="vertical"
                    [attr.aria-label]="'Resize ' + (column || 'column ' + (colIndex + 1))"
                    title="Drag to resize. Double-click to reset."
                    class="rich-table__col-divider rich-table__col-divider--header"
                    [class.rich-table__col-divider--active]="resizingColumnIndex === colIndex"
                    (pointerdown)="startColumnResize(colIndex, $event)"
                    (dblclick)="resetColumnWidths($event)"
                  ></span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of pagedRows; let rowIndex = index" #bodyRow>
                <td
                  *ngFor="let column of tableData.columns; let colIndex = index"
                  [class]="cellDensityClass(column) + rowSizedCellClass(globalRowIndex(rowIndex))"
                  [ngStyle]="rowSizeStyle(globalRowIndex(rowIndex))"
                >
                  <span
                    *ngIf="usePlainTextCells; else bodyRichMarkdown"
                    class="rich-table__cell-content"
                  >{{ row[colIndex] }}</span>
                  <ng-template #bodyRichMarkdown>
                    <span
                      class="rich-table__cell-content"
                      [innerHTML]="cellMarkdownSource(row[colIndex]) | sanitizeMarkdown"
                    ></span>
                  </ng-template>
                  <span
                    *ngIf="canResizeColumns && colIndex < tableData.columns.length - 1"
                    aria-hidden="true"
                    class="rich-table__col-divider"
                    [class.rich-table__col-divider--active]="resizingColumnIndex === colIndex"
                    (pointerdown)="startColumnResize(colIndex, $event)"
                    (dblclick)="resetColumnWidths($event)"
                  ></span>
                  <span
                    *ngIf="canResizeRows && globalRowIndex(rowIndex) < totalRows - 1"
                    aria-hidden="true"
                    title="Drag to resize row height. Double-click to reset all row heights."
                    class="rich-table__row-divider"
                    [class.rich-table__row-divider--active]="resizingRowIndex === globalRowIndex(rowIndex)"
                    (pointerdown)="startRowResize(globalRowIndex(rowIndex), $event)"
                    (dblclick)="resetRowHeights($event)"
                  ></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <footer *ngIf="shouldPaginate && !isRia" class="rich-table__pagination" aria-label="Table pagination">
      <ng-container *ngTemplateOutlet="paginationControls"></ng-container>
    </footer>
  </ng-container>
  </div>

  <footer
    *ngIf="shouldPaginate && isRia"
    class="rich-table__pagination rich-table__pagination--external"
    aria-label="Table pagination"
  >
    <span class="rich-table__pagination-summary">{{ paginationSummaryLabel }}</span>
    <ng-container *ngTemplateOutlet="paginationControls"></ng-container>
  </footer>
</div>

<ng-template #paginationControls>
  <label class="rich-table__rows-label">
    Rows per page:
    <select
      class="rich-table__rows-select"
      [ngModel]="rowsPerPage"
      (ngModelChange)="onRowsPerPageChange($event)"
    >
      <option *ngFor="let size of rowsPerPageOptions" [ngValue]="size">{{ size }}</option>
    </select>
  </label>
  <span class="rich-table__pagination-range">{{ rangeStart }}-{{ rangeEnd }} of {{ totalRows }}</span>
  <div class="rich-table__pagination-nav">
    <button
      type="button"
      class="rich-table__pagination-button"
      (click)="previousPage()"
      [disabled]="safePageIndex === 0"
      aria-label="Previous page"
    >
      &lt;
    </button>
    <button
      type="button"
      class="rich-table__pagination-button"
      (click)="nextPage()"
      [disabled]="safePageIndex >= totalPages - 1"
      aria-label="Next page"
    >
      &gt;
    </button>
  </div>
</ng-template>

<div
  *ngIf="openFilterColumnIndex !== null && tableData"
  #filterMenuPortal
  class="rich-table__filter-menu rich-table__filter-menu--portal"
  role="listbox"
  [attr.aria-label]="'Filter values for ' + (tableData.columns[openFilterColumnIndex] || 'column')"
  (click)="$event.stopPropagation()"
  (keydown)="$event.stopPropagation()"
>
  <div class="rich-table__filter-menu-search">
    <div class="rich-table__filter-menu-search-field">
      <img
        src="assets/icons/search.svg"
        alt=""
        class="rich-table__filter-menu-search-icon"
        aria-hidden="true"
      />
      <input
        type="search"
        class="rich-table__filter-menu-search-input"
        placeholder="Search..."
        [value]="filterMenuSearchQuery"
        (input)="onFilterMenuSearchInput($event)"
        (keydown)="onFilterMenuSearchKeydown($event)"
        aria-label="Search filter values"
        autocomplete="off"
      />
    </div>
  </div>
  <ul class="rich-table__filter-options">
    <li
      *ngFor="let value of getColumnFilterOptions(openFilterColumnIndex)"
      class="rich-table__filter-option"
      [class.rich-table__filter-option--selected]="isColumnFilterValueSelected(openFilterColumnIndex, value)"
      role="option"
      tabindex="0"
      [attr.aria-selected]="isColumnFilterValueSelected(openFilterColumnIndex, value)"
      (click)="toggleColumnFilterValue(openFilterColumnIndex, value, $event)"
      (keydown)="onFilterOptionKeydown($event, openFilterColumnIndex, value)"
    >
      <span class="rich-table__filter-option-label">{{ columnFilterDisplayValue(value) }}</span>
      <span
        *ngIf="isColumnFilterValueSelected(openFilterColumnIndex, value)"
        class="rich-table__filter-option-check"
        aria-hidden="true"
      >&#10003;</span>
    </li>
  </ul>
</div>

<div
  *ngIf="showDownloadModal"
  #downloadOverlay
  class="rich-table-download-overlay"
  tabindex="-1"
  role="presentation"
  (click)="closeDownloadModal($event)"
  (keydown)="onDownloadOverlayKeydown($event)"
>
  <div
    class="rich-table-download-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="rich-table-download-title"
    (click)="$event.stopPropagation()"
    (keydown)="onDownloadOverlayKeydown($event)"
  >
    <div class="rich-table-download-modal__header">
      <h2 id="rich-table-download-title" class="rich-table-download-modal__title">Download</h2>
      <button
        type="button"
        class="rich-table-download-modal__close"
        aria-label="Close download dialog"
        (click)="closeDownloadModal($event)"
      >
        &times;
      </button>
    </div>

    <div class="rich-table-download-modal__body">
      <label class="rich-table-download-modal__label" for="rich-table-download-filename">
        Input the name of the file to download
        <span class="rich-table-download-modal__required" aria-hidden="true">*</span>
      </label>
      <input
        id="rich-table-download-filename"
        type="text"
        class="rich-table-download-modal__input"
        name="rich-table-download-filename"
        [(ngModel)]="downloadFileName"
        (keydown.enter)="confirmDownload($event)"
      />
    </div>

    <div class="rich-table-download-modal__footer">
      <button
        type="button"
        class="rich-table-download-modal__button rich-table-download-modal__button--cancel"
        (click)="closeDownloadModal($event)"
      >
        Cancel
      </button>
      <button
        type="button"
        class="rich-table-download-modal__button rich-table-download-modal__button--primary"
        [disabled]="!isDownloadFileNameValid"
        (click)="confirmDownload($event)"
      >
        Download
      </button>
    </div>
  </div>
</div>
